import { render, staticRenderFns } from "./ResendActivation.vue?vue&type=template&id=d8b95382&scoped=true&"
import script from "./ResendActivation.vue?vue&type=script&lang=js&"
export * from "./ResendActivation.vue?vue&type=script&lang=js&"
import style0 from "./ResendActivation.vue?vue&type=style&index=0&id=d8b95382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b95382",
  null
  
)

export default component.exports